import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { RouteHistoryService } from '../../services/route-history.service';

@Component({
  selector: 'app-go-back',
  templateUrl: './go-back.component.html',
  styleUrls: ['./go-back.component.scss']
})
export class GoBackComponent implements OnInit {
  
  @Input() margin: string = '3rem';
  @Input() navigateTo?: { path: string; queryParams?: Record<string, any> };
  showGoBackButton = true;
  
  constructor(private router: Router, private routeHistoryService: RouteHistoryService) {}


  ngOnInit(): void {
    this.checkShowGoBackButton();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {        
        this.checkShowGoBackButton();
      });
    }
  
  checkShowGoBackButton() {
    const url = this.router.url;
    // Check if the URL path has only one segment
    const segments = url.split('/').filter(segment => segment.length > 0);
    if(segments.length === 1) {
      this.showGoBackButton = false;
    } else {
      this.showGoBackButton = true;
    }
  }
  
  goBack() {
    if (this.navigateTo?.path) {
      this.router.navigate([this.navigateTo.path], { queryParams: this.navigateTo.queryParams || {} });
    } else if (this.routeHistoryService.hasPreviousRoute()) {
      window.history.back();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

}
